import * as React from "react";
const SvgFiRrCoffeePot = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-coffee-pot_svg__a)">
      <path
        fill="#062147"
        d="M22.113 3.157A4.96 4.96 0 0 0 17.463 0H3a1.008 1.008 0 0 0-.929 1.372l1.81 4.521A30.5 30.5 0 0 0 .026 18.47 5.01 5.01 0 0 0 5 24h11a5.043 5.043 0 0 0 4.976-5.53A30.1 30.1 0 0 0 17 5.7V2a3.09 3.09 0 0 1 3.252 1.89A25.2 25.2 0 0 1 22 13a1 1 0 1 0 2 0 27.3 27.3 0 0 0-1.887-9.843m-3.89 17.85A2.96 2.96 0 0 1 16 22H5c-4.4-.266-2.719-5.4-2.176-8H15a1 1 0 0 0 0-2H3.387A24.2 24.2 0 0 1 5.55 7h9.9a29.1 29.1 0 0 1 3.533 11.677 3.02 3.02 0 0 1-.76 2.33M15 5H5.677l-1.2-3H15z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-coffee-pot_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCoffeePot;
